// components/HighlightableText/index.js
import HighlightableText from './HighlightableText'

export default HighlightableText
export { HighlightableText }